import { Variable } from './variable';
import { VariableType } from './variable-type.enum';
import { VariableValue } from './variable-value';

export class DependentVariable extends Variable {
    constructor(index: number, key: string, formula: string, values: VariableValue[]) {
       super(index, key, VariableType.Dependent, formula, values);
    }
}
